import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Category } from "../../services/Catalog Management";
import adapter from "../../adapters/category";

import { select as categoryTypeSelect } from "./category_type";
import { addTitleOption, createOptions } from "src/utils/select";

const service = new Category();

const REDUCER_MODULE_NAME = "CATEGORY";

const initialState = {
  grid: {
    activos: {
      page: 1,
      skip: 0,
      take: 3,
      rows: 0,
      data: [],
    },
    inactivos: {
      page: 1,
      skip: 0,
      take: 3,
      rows: 0,
      data: [],
    },
  },
  loading: false,
  select: [],
  formIsReady: false,
  data: "",
  message: "",
  error: "",
};

const loadingReducer = (state, _) => {
  return {
    ...state,
    formIsReady: false,
    loading: true,
  };
};

export const grid_activos = createAsyncThunk(
  `GRID_ACTIVOS_${REDUCER_MODULE_NAME}`,
  async ({ skip, take, currentPage = 1 }) => {
    const { data } = await service.grid(skip, take, 1);

    return {
      skip,
      take,
      grid_data: data,
      page: currentPage,
    };
  },
);

export const grid_inactivos = createAsyncThunk(
  `GRID_INACTIVOS_${REDUCER_MODULE_NAME}`,
  async ({ skip, take, currentPage = 1 }) => {
    const { data } = await service.grid(skip, take, 0);

    return {
      skip,
      take,
      grid_data: data,
      page: currentPage,
    };
  },
);

export const changeActive = createAsyncThunk(
  `CHANGE_ACTIVE_${REDUCER_MODULE_NAME}`,
  async ({ id, active }, { dispatch, getState }) => {
    await service.changeActive(id, { active: !active });

    dispatch(
      grid_activos({
        skip: initialState.grid.activos.skip,
        take: initialState.grid.activos.take,
      }),
    );
    dispatch(
      grid_inactivos({
        skip: initialState.grid.inactivos.skip,
        take: initialState.grid.inactivos.take,
      }),
    );
  },
);

export const select = createAsyncThunk(
  `SELECT_${REDUCER_MODULE_NAME}`,
  async () => {
    const { data } = await service.select();

    return {
      entities: addTitleOption(createOptions(data, ["id", "name"])),
    };
  },
);

export const form = createAsyncThunk(
  `FORM_${REDUCER_MODULE_NAME}`,
  async (id, { dispatch }) => {
    dispatch(categoryTypeSelect());
    if (id) {
      dispatch(getById(id));
    }

    return {
      loading: false,
    };
  },
);

export const getById = createAsyncThunk(
  `GET_${REDUCER_MODULE_NAME}`,
  async (id) => {
    const entity = await service.getById(id);

    return {
      entity: entity.data,
    };
  },
);

export const submit = createAsyncThunk(
  `SUBIMIT_FORM_${REDUCER_MODULE_NAME}`,
  async ({ id, data }) => {
    try {
      if (id) {
        await service.update(id, data);
      } else {
        await service.create(data);
      }

      return {
        error: "",
        message: `Categoría ${id ? "modificada" : "creada"} correctamente.`,
      };
    } catch (error) {
      return {
        error: error.message,
        message: "",
      };
    }
  },
);

export const slice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    clean() {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: {
    [grid_activos.pending.type]: loadingReducer,
    [grid_inactivos.pending.type]: loadingReducer,
    [getById.pending.type]: loadingReducer,
    [select.pending.type]: loadingReducer,
    [form.pending.type]: loadingReducer,
    //[submit.pending.type]: loadingReducer,

    [grid_activos.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: "",
        grid: {
          ...state.grid,
          activos: {
            ...state.grid.activos,
            page: action.payload.page,
            skip: action.payload.skip,
            take: action.payload.take,
            rows: action.payload.grid_data.rows,
            data: adapter.from_api_to_grid(action.payload.grid_data.data),
          },
        },
      };
    },
    [grid_inactivos.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: "",
        grid: {
          ...state.grid,
          inactivos: {
            ...state.grid.inactivos,
            page: action.payload.page,
            skip: action.payload.skip,
            take: action.payload.take,
            rows: action.payload.grid_data.rows,
            data: adapter.from_api_to_grid(action.payload.grid_data.data),
          },
        },
      };
    },
    [select.fulfilled.type]: (state, action) => {
      return {
        ...state,
        select: action.payload.entities,
      };
    },
    [getById.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload.entity,
      };
    },
    [form.fulfilled.type]: (state, action) => {
      return {
        ...state,
        message: "",
        loading: false,
        formIsReady: false,
      };
    },
    [submit.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        formIsReady: !!action.payload.message,
        error: action.payload.error,
      };
    },
  },
});

export const { clean } = slice.actions;

export default slice.reducer;
